import React from 'react';
import * as Styled from './styled';

const PromoEmbedSocial = ({}) => {
  return (
    <>
      <iframe
        frameBorder={0}
        src="https://app.reviewflowz.com/iframes/3b4a901f-fc29-4ea7-b425-be959320d339"
        id="rvwflwz-3b4a901f-fc29-4ea7-b425-be959320d339"
        style={{
          width: '1px',
          minWidth: '100%',
          height: '100vh',
        }}
      ></iframe>
    </>
  );
};

export default PromoEmbedSocial;
